import { AppState } from '@/store';

export const selectIsAuthorized = (state: AppState) => !!state.auth.login?.token;
export const selectAuthState = (state: AppState) => state.auth.login;
export const selectShowSetPasswordSuccess = (state: AppState) => state.auth.showSetPasswordSuccess;
export const selectLoginLoading = (state: AppState) => state.auth.login?.loading;
export const selectLoginError = (state: AppState) => state.auth.login?.error;
export const selectFlag = (state: AppState) => state.auth.login.flag;
export const selectHelpersShown = (state: AppState) => state.auth.login.helpersShown;
export const selectPaymentInfoPopupShown = (state: AppState) => state.auth.login.paymentInfoPopupShown;
export const selectIntercomAuthenticatedSession = (state: AppState) => state.auth.intercomAuthenticatedSession;

// Reset password
export const resetLoading = (state: AppState) => !!state.auth.resetPassword?.loading;

// Code data
export const selectIsCustomerAIChatEnabled = (state: AppState) => {
    return state.auth.codeData.data?.featuresEnabled?.includes('customerAIChatEnabled') ?? false;
}
export const selectAIAssociateId = (state: AppState) => state.auth.codeData.data?.AIAssociateId ?? null;
export const selectOperatorIdleWarningSecs = (state: AppState) => state.auth.codeData.data?.OperatorIdleWarningSecs ?? null;

//add is code data loaded selector 
export const selectIsCodeDataLoaded = (state: AppState) => state.auth.codeData.data != null;

// true once code-data has either loaded successfully or failed, so callers can stop waiting and fall back
export const selectIsCodeDataSettled = (state: AppState) => state.auth.codeData.data != null || state.auth.codeData.error;

export const selectIsApChatEnabled = (state: AppState) => {
    return selectIsCodeDataLoaded(state) && selectIsAuthorized(state) && selectIsCustomerAIChatEnabled(state) && selectAIAssociateId(state) !== null;
};